export const ARTICLES_GET_ARTICLES = "ARTICLES_GET_ARTICLES";
export const ARTICLES_GET_ARTICLES_REQUESTED =
  "ARTICLES_GET_ARTICLES_REQUESTED";
export const ARTICLES_GET_ARTICLES_SUCCESS = "ARTICLES_GET_ARTICLES_SUCCESS";
export const ARTICLES_GET_ARTICLES_FAILED = "ARTICLES_GET_ARTICLES_FAILED";
export const ARTICLES_GET_ARTICLES_CLEAR = "ARTICLES_GET_ARTICLES_CLEAR";

export const ARTICLES_GET_ARTICLES_PAGINATED =
  "ARTICLES_GET_ARTICLES_PAGINATED";
